import * as React from 'react';

import { useFieldControl } from '@/components/ui/field-context';
import { cn } from '@/lib/utils';

/** Zone de texte (`textarea.input` des maquettes) : mêmes contour et focus que `Input`. */
const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    const a11y = useFieldControl(props);
    return (
      <textarea
        className={cn(
          'flex min-h-[60px] w-full resize-y rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground',
          'placeholder:text-muted-foreground',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
          'disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground',
          'aria-[invalid=true]:border-danger-fg',
          className,
        )}
        ref={ref}
        {...props}
        {...a11y}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
